//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @author Rico
import { getIndex, addClass, removeClass } from "@/utils/dom";
import axios from "axios";
import qs from "qs";

export default {
  name: "ArticleRating",
  componentName: "ArticleRating",

  props: {
    // 评分
    rating: {
      type: Number,
      default: 5,
    },
    // reviews条数
    total: {
      type: Number,
      default: 0,
    },
    // 颜色
    color: {
      type: String,
      default: "",
    },
    // 尺寸
    size: {
      type: String,
      default: "normal",
      validator(val) {
        return ["normal", "small"].includes(val);
      },
    },

    readOnly: {
      type: Boolean,
      default: false,
    },

    showCount: {
      type: Boolean,
      default: true,
    },

    showLabel: {
      type: Boolean,
      default: false,
    },

    labels: {
      type: Array,
      // default: () => ["Poor", "Fair", "Average", "Good", "Excellent"]
      default: null,
    },

    productId: {
      type: Number,
      default: 0,
    },

    posturl: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      width: "100%",
      label: "",
      language: null,
      langLabels: null,
      // 多语言翻译字段
      labelMap: {
        Poor: "Rating.Poor",
        Fair: "Rating.Fair",
        Average: "Rating.Average",
        Good: "Rating.Good",
        Excellent: "Rating.Excellent",
      },
    };
  },

  mounted() {
    this.language = document.documentElement.lang || "en";
    this.langLabels = this.labels;
    if (!this.langLabels) {
      let arr = ["Poor", "Fair", "Average", "Good", "Excellent"];
      let labels = [];
      arr.forEach((item) => {
        let text = this.$t(this.labelMap[item]);
        labels.push(text);
      });
      this.langLabels = labels;
    }
    this.label = this.langLabels[Math.floor(this.rating)];
  },

  methods: {
    onMouseenter(event) {
      if (!this.readOnly) {
        const target = event.target;
        const index = getIndex(target);
        const arr = Array.prototype.slice.call(target.parentNode.childNodes);
        this.label = this.langLabels[index];
        arr.forEach((ele, i) => {
          removeClass(ele, "active");
          if (i <= index) {
            addClass(ele, "active");
          }
        });
      }
    },
    onMouseleave(event) {
      if (!this.readOnly) {
        const target = event.target;
        // const index = getIndex(target);
        const arr = Array.prototype.slice.call(target.parentNode.childNodes);
        this.label = this.langLabels[Math.floor(this.rating)];
        arr.forEach((ele) => {
          removeClass(ele, "active");
        });
      }
    },

    onClickStar(e, i) {
      // 文章页面中的评分 有posturl
      if (!this.posturl) {
        return;
      }
      this.sendRatingData(i + 1);
    },
    sendRatingData(rating) {
      const data = {
        rating: rating,
      };
      axios
        .post(this.posturl, qs.stringify(data), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          let data = res.data;
          if (data.state == 1) {
            this.showThanksEl();
          }
          this.disabledEl();
        })
        .catch((e) => {
          console.log(e);
          this.disabledEl();
        });
    },
    showThanksEl() {
      let thanksEl = null;
      //   thanksEl: '.rating-thanks',
      if (document.getElementsByClassName("rating-thanks").length) {
        thanksEl = document.getElementsByClassName("rating-thanks")[0];
        thanksEl.className = "rating-thanks active";
      }
    },
    disabledEl() {
      this.$el.parentElement.setAttribute("disabled", "disabled");
    },
  },
};
